<fgb-banner [pageTitle]="'challenges.page.title' | translate"></fgb-banner>
<fgb-page-header [pageTitle]="'challenges.page.title'"></fgb-page-header>
<div class="mobile-content-wrapper container">
  <div class="mt-lg-30">
    <fgbcl-badge-achieved />
  </div>

  <!--Scorecards-->
  <div class="mt-20 mt-lg-30">
    <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
  </div>
</div>
